// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4341) return "4341.bea2993f35ef1663fe97.css";
	if (chunkId === 3367) return "3367.bea2993f35ef1663fe97.css";
	// return url for filenames based on template
	return "" + (chunkId === 3524 ? "app" : chunkId) + "." + {"991":"c43b377308760377758b","3524":"0414ccc420d99ac2088a"}[chunkId] + ".css";
};